import { Component, OnInit, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from '../../../services/event-managers/toolbar-event-manager.helper';
import { DashboardHelper } from '../../../services/dashboard.service';
import * as AppConstants from '../../../modules/catch-core/data/constants/app.constants';
import { Select } from 'primeng/select';

export interface ColorModeSelection {
  coloredHeaders: boolean;
  coloredColumns: boolean;
}

export interface ColorOption {
  key: 'headers' | 'columns';
  label: string;
  checked: boolean;
}

@Component({
  selector: 'app-agile-board-color-options',
  templateUrl: './agile-board-color-options.component.html',
  styleUrl: './agile-board-color-options.component.scss',
  standalone: false,
})
export class AgileBoardColorOptionsComponent extends BaseComponent implements OnInit {
  @ViewChild('boardStyleSelect') boardStyleSelect?: Select;
  public showColorOptions: boolean = false;
  public coloredHeaders: boolean = true;
  public coloredColumns: boolean = true;
  public selectedDisplay: ColorOption = { key: 'headers', label: 'Headers Coloured', checked: true };

  public colorOptions: { value: ColorOption; label: string }[] = [];

  constructor(
    private dashboardHelper: DashboardHelper,
    private toolbarEventManagerHelper: ToolbarEventManagerHelper,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit(): void {
    this.subscribers.currentApplication = this.dashboardHelper.$currentApplication.subscribe((res: any) => {
      if (res) {
        const currentAppName = res.displayName ? res.displayName.toLowerCase() : '';
        this.showColorOptions = currentAppName === AppConstants.TRACK;
        this.cdr.detectChanges();
      }
    });

    this.subscribers.colorMode = this.toolbarEventManagerHelper.$AgileBoardColorMode.subscribe((selection) => {
      if (selection) {
        this.coloredHeaders = selection.coloredHeaders;
        this.coloredColumns = selection.coloredColumns;
        this.updateColorOptions();
        this.cdr.detectChanges();
      }
    });
  }

  private updateColorOptions(): void {
    this.colorOptions = [
      { value: { key: 'headers', label: 'Headers Coloured', checked: this.coloredHeaders }, label: 'Board Style' },
      { value: { key: 'columns', label: 'Columns Coloured', checked: this.coloredColumns }, label: 'Board Style' },
    ];
  }

  public onColorCheckboxChange(): void {
    const selection: ColorModeSelection = {
      coloredHeaders: this.coloredHeaders,
      coloredColumns: this.coloredColumns,
    };
    this.toolbarEventManagerHelper.AgileBoardColorMode = selection;
  }

  public onSelectionChange(event: any): void {
    // Keep the dropdown on "Board Style" display - don't change it
    this.selectedDisplay = { key: 'headers', label: 'Headers Coloured', checked: this.coloredHeaders };
  }

  private preventClose: boolean = false;

  public handleOptionClick(event: Event, key: 'headers' | 'columns'): void {
    event.preventDefault();
    event.stopPropagation();
    this.preventClose = true;

    if (key === 'headers') {
      this.coloredHeaders = !this.coloredHeaders;
    } else {
      this.coloredColumns = !this.coloredColumns;
    }
    this.updateColorOptions();
    this.onColorCheckboxChange();

    // Reopen the panel immediately after it closes
    setTimeout(() => {
      if (this.preventClose && this.boardStyleSelect) {
        this.boardStyleSelect.show();
        this.preventClose = false;
      }
    }, 0);
    this.cdr.detectChanges();
  }

  public onPanelHide(): void {
    if (this.preventClose) {
      this.preventClose = false;
    }
  }

  public toggleOption(key: 'headers' | 'columns'): void {
    if (key === 'headers') {
      this.coloredHeaders = !this.coloredHeaders;
    } else {
      this.coloredColumns = !this.coloredColumns;
    }
    this.updateColorOptions();
    this.onColorCheckboxChange();
    this.cdr.detectChanges();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
